import { render, staticRenderFns } from "./TemperatureCard.vue?vue&type=template&id=1212703c&scoped=true&"
import script from "./TemperatureCard.vue?vue&type=script&lang=ts&"
export * from "./TemperatureCard.vue?vue&type=script&lang=ts&"
import style0 from "./TemperatureCard.vue?vue&type=style&index=0&id=1212703c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1212703c",
  null
  
)

export default component.exports